import { reactive } from 'vue'
import { EXAM_DATE } from '../areas/guide/guide-data'
import { PROVINCES } from '../areas/guide/syllabus-data'

// The learner's exam date and registered province. Same storage keys as the production front end
// (assets/js/app.js EXAM_DATE_STORAGE_KEY / EXAM_PROVINCE_STORAGE_KEY), so a browser keeps its choices.
const DATE_KEY = 'jx_exam_date_v1'
const PROVINCE_KEY = 'jx_exam_province_v1'

function read(key: string): string {
  try { return localStorage.getItem(key) || '' } catch { return '' }
}
function write(key: string, value: string) {
  try { localStorage.setItem(key, value) } catch { /* storage unavailable: keep the in-memory value */ }
}

const savedDate = read(DATE_KEY)
const savedProvince = read(PROVINCE_KEY)

export const examPrefs = reactive({
  /** Date picked by the learner, or '' to follow the official written-exam date. */
  customDate: /^\d{4}-\d{2}-\d{2}$/.test(savedDate) ? savedDate : '',
  province: PROVINCES.some(p => p.name === savedProvince) ? savedProvince : '',
  get date() { return this.customDate || EXAM_DATE },
})

export function setExamDate(value: string) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return
  examPrefs.customDate = value
  write(DATE_KEY, value)
}

export function setExamProvince(name: string) {
  if (!PROVINCES.some(p => p.name === name)) return
  examPrefs.province = name
  write(PROVINCE_KEY, name)
}

/** Days from today (calendar date) to `target`; 0 on the day and after it (the legacy counter never goes negative). */
export function daysToExam(target: string, now: Date = new Date()): number | null {
  const t = new Date(`${target}T00:00:00`)
  if (Number.isNaN(t.getTime())) return null
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
  return Math.max(0, Math.ceil((t.getTime() - today.getTime()) / 864e5))
}
